module.exports = __webpack_public_path__ + "static/media/30e4292d-348b-4083-8e12-bff68046c81e.d958e857.JPG";